import React, { useState } from 'react'
import { CssBaseline, Box } from '@mui/material'
import AppBarComponent from './AppBarComponent'
import DrawerComponent from './DrawerComponent'
import logos from '../../data/logos'

const SideBar = () => {
  const [open, setOpen] = useState(true)

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  return (
    <>
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        <AppBarComponent open={open} handleDrawerOpen={handleDrawerOpen} />
        <DrawerComponent
          open={open}
          handleDrawerClose={handleDrawerClose}
          logos={logos}
        />
      </Box>
    </>
  )
}

export default SideBar
